export default "__VITE_ASSET__7D5loHUH__"